import { connect } from 'react-redux';
import NewApiKeyComponent from './NewApiKeyModal';
import { addApiKey as _addApiKey, removeApiKey as _removeApiKey } from '../../../redux/actions/apiKeyActions';
import modalDecorator from '../../../hocs/modalDecorator';
import { MODAL_TYPES } from '../../../redux/actions/modalActions';
import { closeApiKeysSidePane } from '../../../redux/actions/sidePaneActions';
var mapStateToProps = function mapStateToProps(state) {
  return {
    numberOfApiKeys: state.apiKey.apiKeys.length,
    userId: state.user.userInfo.UserId
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    addApiKey: function addApiKey(apiKey) {
      dispatch(_addApiKey(apiKey));
      dispatch(closeApiKeysSidePane());
    },
    removeApiKey: function removeApiKey(apiKey) {
      return dispatch(_removeApiKey(apiKey));
    }
  };
};
var container = connect(mapStateToProps, mapDispatchToProps)(NewApiKeyComponent);
export default modalDecorator({
  name: MODAL_TYPES.NEW_API_KEY
})(container);